<template>
  <footer class="footer bg-white">
    <div class="container">
      <div class="">
        <ul class="nav nav-footer align-items-center">
          <li class="ml-lg-auto">
          <li class="nav-item" v-if="footerLinks.official">
            <a :href="footerLinks.official" class="nav-link" target="_blank" rel="noopener">
              <i class="fa fa-globe fa-2x" aria-hidden="true"></i>
            </a>
          </li>
          <li class="nav-item" v-if="footerLinks.facebook">
            <a :href="footerLinks.facebook" class="nav-link" target="_blank" rel="noopener">
              <i class="fa fa-facebook-square fa-2x" aria-hidden="true"></i>
            </a>
          </li>
          <li class="nav-item" v-if="footerLinks.instagram">
            <a :href="footerLinks.instagram"
               class="nav-link" target="_blank" rel="noopener">
              <i class="fa fa-instagram fa-2x" aria-hidden="true"></i>
            </a>
          </li>
        </ul>
      </div>

      <hr>
      <div class="row align-items-center justify-content-md-between">
        <div class="col-md-6">
          <div class="copyright">
            Copyright &copy; {{ year }} DreamLink All Rights Reserved.
          </div>
        </div>

      </div>
    </div>
  </footer>
</template>
<script>
import * as Api from "@/util/http_api";

export default {
  name: 'app-footer',
  data() {
    return {
      year: new Date().getFullYear(),
      footerLinks: {
        official: null,
        facebook: null,
        instagram: null,
      },
    }
  },
  created() {
    this.fetchFooterLinks();
  },
  methods: {
    async fetchFooterLinks() {
      try {
        this.footerLinks = await Api.getFooterLinks();
      } catch (e) {
        console.error('getFooterLinks error', e);
      }
    },
  },
};
</script>
<style>
</style>
